import Alert from '@mui/joy/Alert'

export const ErrorAlert = ({ children }) => (
    <Alert size="sm" variant="soft" color="danger">
        {children}
    </Alert>
)
